module.exports = __webpack_public_path__ + "img/二维码动效.5cc2008a.gif";